import React from 'react'
import {
   AIFinancialIcon,
   AIPoweredLearningIcon,
   ContinuousSupportIcon,
   CustomEducationSoftwareIcon,
   CustomFintechIcon,
   OmnichannelLearningIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureCompliantIcon,
   SecureTransactionsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Education Software',
      subtitle: 'Tailored Platforms for Schools and Training',
      description:
         'We build custom education applications, including LMS, virtual classrooms, and AI-powered tutoring platforms, ensuring seamless learning experiences.',
      icon: <CustomEducationSoftwareIcon />,
   },
   {
      title: 'AI-Powered Learning Analytics',
      subtitle: 'Smart Insights and Performance Tracking',
      description:
         'We implement AI-driven analytics that monitor student engagement, learning patterns, and exam performance, helping educators optimize teaching strategies.',
      icon: <AIPoweredLearningIcon />,
   },
   {
      title: 'Secure and Compliant Systems',
      subtitle: 'Data Privacy and Compliance Standards',
      description:
         'We ensure GDPR, FERPA, and education compliance standards, integrating end-to-end encryption and fraud detection for secure learning platforms.',
      icon: <SecureCompliantIcon />,
   },
   {
      title: 'Omnichannel Learning Experience',
      subtitle: 'Web, Mobile, and Cloud Integration',
      description:
         'We develop education software that seamlessly integrates with mobile apps, cloud-based storage, and web platforms, providing a consistent learning experience.',
      icon: <OmnichannelLearningIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'High-Performance and Remote Access',
      description:
         'Our cloud-powered education solutions enable real-time collaboration, remote access, and scalable storage, allowing institutions to manage large numbers of learners efficiently.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Ongoing Maintenance and Feature Updates',
      description:
         'We deliver 24x7 technical assistance, security fixes, and feature improvements to ensure that education portals are competitive and future-proofed.',
      icon: <ContinuousSupportIcon />,
   },
]

function EducationWhyChoose() {
   return (
      <WhyChooseOur
         title={'Why Choose Our Education Software Development Services?'}
         desc={
            'We create safe, scalable, and innovative EdTech products to make learning efficient, engaging, and accessible. Here’s why businesses and institutions choose Benzatine:'
         }
         cardData={featureCards}
         otherUi={true}
      />
   )
}

export default EducationWhyChoose
